import { render, staticRenderFns } from "./PrepostHomeDashSroColumn.vue?vue&type=template&id=7f4cdd6d&scoped=true"
import script from "./PrepostHomeDashSroColumn.vue?vue&type=script&lang=js"
export * from "./PrepostHomeDashSroColumn.vue?vue&type=script&lang=js"
import style0 from "./PrepostHomeDashSroColumn.vue?vue&type=style&index=0&id=7f4cdd6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cdd6d",
  null
  
)

export default component.exports